import { RouteConfig } from "vue-router";
const home = () => import("./home.vue");
const notFound = () => import("@/apps/shared/components/notFound.vue");
import webSalesSettingService from '@/apps/shared/services/webSalesSettings-service';
import FilePathService from '@/apps/shared/services/filePath-service';
import { safeRedirect } from '@/apps/shared/utils/safeRedirectHelper';
const pageTitle = 'Multicotizador';

const routes: Array<RouteConfig> = [
    {
        path: "/",
        name: "HomeRedirect",
        beforeEnter: async (to: any, from: any, next: any): Promise<void> => {
            try {
                NF.UI.Page.block();
                const response = await FilePathService.getFilePath("URLSancorSeguros")
                await safeRedirect(response.toString(), next);
            } catch{
                next({ name: 'not-found' });
            }

        }
    },
    {
        path: "/:pathMatch(.*)*",
        name: "home",
        component: home,
        props: (route) => {
            return {
                home: route.params.home
            };
        },
        meta: {
            pageTitle: pageTitle,
        },
        beforeEnter: async (to: any, from: any, next: any): Promise<void> => {
            NF.UI.Page.block();
            try {
                const response = await webSalesSettingService.getHomeSettings(to.fullPath);
                if (response) {
                    if (Array.isArray(response.products) && response.products.length == 1) {
                        const productPath = response.products[0].path;
                        await safeRedirect(productPath, next);
                    }
                    else {
                        to.params.home = {
                            urlSite: response.urlSite,
                            navbar: response.navbar,
                            products: response.products,
                        };
                        next();
                    }
                } else {
                    next({ name: 'not-found' });
                }
            }
            catch {
                next({ name: 'not-found' });
            } finally {
                NF.UI.Page.unblock();
            }
        }
    },
    {
        path: '/notFound',
        name: 'not-found',
        component: notFound,
    }
];

export default routes;